import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { decideAuthGate, LOGIN_PATH } from "../lib/auth-gate";

export function ProtectedRoute() {
  const { configured, loading, session } = useAuth();
  const location = useLocation();

  const decision = decideAuthGate({
    configured,
    loading,
    hasSession: session !== null,
    pathname: location.pathname,
  });

  if (decision.kind === "loading") {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen" role="status" aria-live="polite">
        <div className="animate-spin rounded-full h-8 w-8 border-3 border-[var(--color-primary)] border-t-transparent" aria-hidden="true"></div>
        <p className="mt-4 text-[var(--color-text-muted)]">Restaurando sessão...</p>
      </div>
    );
  }

  if (decision.kind === "redirect") {
    return <Navigate to={decision.to} replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

export { LOGIN_PATH };
